import { ReactNode } from 'react';
import { Modal } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { CloseModalIcon } from '../svgs/svgs';

interface DefaultModalProps {
  id: number;
  size?: 'sm' | 'lg' | 'xl';
  addHeader?: string;
  updateHeader?: string;
  isLoading?: boolean;
  children?: ReactNode;
  className?: string;
  onModalClosed: () => void;
}

const DefaultModal = (props: DefaultModalProps) => {
  return (
    <Modal
      className={props.className}
      size={props.size}
      show={true}
      centered
      onHide={() => {}}
    >
      <Modal.Header>
        <Modal.Title>
          {props.id < 0 ? (
            <FormattedMessage id={props.addHeader} />
          ) : (
            <FormattedMessage id={props.updateHeader} />
          )}
          <button
            onClick={props.onModalClosed}
            disabled={props.isLoading}
            className="Crossicons"
          >
            <CloseModalIcon />
          </button>
        </Modal.Title>
      </Modal.Header>
      <div>{props.children}</div>
    </Modal>
  );
};

export default DefaultModal;
